import React from 'react'
import classNames from 'classnames'

import InnerContent from 'components/InnerContent'
import style from './style.module.css'

type Props = {
  children: React.ReactNode
  color?: 'black'
  className?: string
}

function Section({ children, className, color }: Props) {
  return (
    <section className={classNames(style.wrapper, className, style[color])}>
      <InnerContent variant='xlarge'>{children}</InnerContent>
    </section>
  )
}

export default Section
